import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './WhyHaazri.css';

const WhyHaazri = () => {
  const [title, setTitle] = useState('Why Replace Traditional Attendance Systems?');
  const [problems, setProblems] = useState([
    {
      id: 1,
      icon: '💰',
      title: 'Biometric devices are costly',
      description: 'Frequent breakdowns, maintenance, and hardware costs.'
    },
    {
      id: 2,
      icon: '📝',
      title: 'Manual registers are error-prone',
      description: 'Easy to manipulate, slow, and unreliable.'
    },
    {
      id: 3,
      icon: '🏠',
      title: 'No support for remote or hybrid work',
      description: 'Outdated methods fail in modern workplaces.'
    },
    {
      id: 4,
      icon: '📊',
      title: 'Data not centralized',
      description: 'Scattered attendance records waste HR time.'
    }
  ]);
  const [solution, setSolution] = useState('Haazri solves all these problems with a cloud attendance app that works anytime, anywhere.');

  useEffect(() => {
    fetchWhyHaazri();
  }, []);

  const fetchWhyHaazri = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const sections = response.data.data.sections || [];
        const whySection = sections.find(s => s.section_key === 'why_haazri');

        if (whySection && whySection.content) {
          const titleContent = whySection.content.find(c => c.content_key === 'why_title');
          const solutionContent = whySection.content.find(c => c.content_key === 'why_solution');
          const problemsContent = whySection.content.filter(c => c.content_key.startsWith('problem_'));

          if (titleContent) setTitle(titleContent.content_value);
          if (solutionContent) setSolution(solutionContent.content_value);

          if (problemsContent.length > 0) {
            const parsedProblems = problemsContent.map(p => {
              const metadata = JSON.parse(p.metadata || '{}');
              return {
                id: p.id,
                icon: metadata.icon || '⚠️',
                title: metadata.title || '',
                description: p.content_value
              };
            });
            setProblems(parsedProblems);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch Why Haazri:', error);
    }
  };

  return (
    <section className="why-haazri" id="why-haazri">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
        </div>
        <div className="problems-grid">
          {problems.map((problem) => (
            <div key={problem.id} className="problem-card">
              <div className="problem-icon">{problem.icon}</div>
              <h3>{problem.title}</h3>
              <p>{problem.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyHaazri;
